module.exports = __webpack_public_path__ + "img/previewImg6.c97769f5.png";